/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Link } from "@farmlands/shadcn-ui";
import { FC, type JSX } from "react";
import { useSelector } from "react-redux";

import { selectRemoteConfig } from "../../../../services/firebase/remote-config/remoteConfig.slice";
import TestIds from "../../../../testIds";

const UserAgreements: FC = (): JSX.Element | undefined => {
  const remoteConfig = useSelector(selectRemoteConfig);

  const privacyPolicyUrl: string | undefined = remoteConfig.privacyPolicyUrl?.trim();
  const termsAndConditionsUrl: string | undefined = remoteConfig.termsAndConditionsUrl?.trim();

  if (!privacyPolicyUrl && !termsAndConditionsUrl) {
    return undefined;
  }

  return (
    <div
      className="flex flex-col items-start gap-3"
      data-testid={TestIds.feat.account.userAccount.userAgreements.component}
    >
      {privacyPolicyUrl && (
        <Link
          href={privacyPolicyUrl}
          target="_blank"
          rel="noreferrer"
          size="2xs"
          data-testid={TestIds.feat.account.userAccount.userAgreements.privacyLink}
        >
          Privacy Policy
        </Link>
      )}

      {termsAndConditionsUrl && (
        <Link
          href={termsAndConditionsUrl}
          target="_blank"
          rel="noreferrer"
          size="2xs"
          data-testid={TestIds.feat.account.userAccount.userAgreements.termsLink}
        >
          App Terms and Conditions
        </Link>
      )}
    </div>
  );
};

export default UserAgreements;
